<mat-sidenav-container class="sidebar-container" [hasBackdrop]="false">
    <mat-sidenav #sidenav="matSidenav" [opened]="(screenWidth > 640) ? 'true' : 'false'"
        [mode]="(screenWidth > 640) ? 'side' : 'over'" class="sidebar-nav">
        
        <div class="sidebar-header">
            <img src="../../../assets/logo.png" [routerLink]="['/']"
                class="sidebar-logo sidebar-logo--main">
            <img src="../../../assets/logoWiGrow.jfif" [routerLink]="['/']"
                class="sidebar-logo sidebar-logo--secondary">
        </div>
        
        <hr class="sidebar-divider" />
        
        <div class="sidebar-controls-container">
            <a *ngIf="superuser || admin || subadmin" [routerLink]="['/admin-page']" class="sidebar-link sidebar-link--admin">
                <i class="pr-4 fas fa-comment-dots sidebar-icon"></i>
                {{'SIDEBAR.ADMIN_PAGE' | translate }}
            </a>
            
            <div *ngIf="(superuser || admin || subadmin) && !featureFlags.isFeatureEnabled('showUruguay')" class="sidebar-title-wrapper">
                <div class="sidebar-title">
                    {{'SIDEBAR.TITLE' | translate }}
                </div>
            </div>
            
            <div *ngIf="(superuser || admin || subadmin)">
                <div id="side_menu">
                    
                    <div class="sidebar-select-button"
                        mat-button matTooltip="{{ 'SIDEBAR.KYD_TOOLTIP' | translate }}"
                        [matMenuTriggerFor]="kydNamesMenu" 
                        [matMenuTriggerRestoreFocus]="false">
                        <i class="fa-solid fa-building sidebar-icon"></i>
                        <span class="sidebar-select-text">
                            {{ selectedKyd || ('FLY.SELECT_KYD' | translate) }}
                        </span>
                    </div>
                    
                    <mat-menu #kydNamesMenu="matMenu">
                        <button mat-menu-item *ngFor="let kyd of kydNames" (click)="selectKyd(kyd)">
                            {{ kyd }}
                        </button>
                    </mat-menu>

                    <div *ngIf="selectedKyd" class="sidebar-select-button"
                        mat-button matTooltip="{{ 'SIDEBAR.FARMER_TOOLTIP' | translate }}"
                        [matMenuTriggerFor]="farmersMenu" 
                        [matMenuTriggerRestoreFocus]="false">
                        <i class="fa-solid fa-user sidebar-icon"></i>
                        <span class="sidebar-select-text">
                            {{ (selectedFarmer ? selectedFarmer : ('SIDEBAR.SELECT_FARMER' | translate)) }}
                        </span>
                    </div>
                    
                    <mat-menu #farmersMenu="matMenu" [hasBackdrop]="true" class="farmers-menu-panel">
                        <div class="farmers-menu" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                            <div class="farmers-menu__search">
                                <mat-form-field class="no-close">
                                    <mat-label>{{'SIDEBAR.SEARCH' | translate }}</mat-label>
                                    <input matInput
                                        [formControl]="currentFarmerSearchControl"
                                        (click)="$event.stopPropagation()"
                                        (focus)="$event.stopPropagation()"
                                        (keydown)="$event.stopPropagation()" />
                                </mat-form-field>
                            </div>
                            <div class="farmers-menu__list">
                                <button mat-menu-item *ngFor="let farmer of currentFilteredFarmers | async"
                                    (click)="selectFarmer(farmer)">
                                    {{ farmer.first_name }} {{ farmer.last_name }}
                                </button>
                            </div>
                        </div>
                    </mat-menu>
                </div>
            </div>
            
            <div *ngIf="this.osdeYears.length > 0" class="sidebar-year-select-wrapper">
                <div class="sidebar-select-button"
                    mat-button [matMenuTriggerFor]="osdeYearsMenu" matTooltip="{{ 'SIDEBAR.OSDE_TOOLTIP' | translate }}"
                    [matMenuTriggerRestoreFocus]="false">
                    <i class="fa-solid fa-calendar-days sidebar-icon"></i>
                    <span class="sidebar-select-text">
                        {{ selectedYear }}
                    </span>
                </div>
               <mat-menu #osdeYearsMenu="matMenu">
    <button mat-menu-item *ngFor="let year of osdeYears"
        (click)="selectYear(year)">
        {{ year }}
    </button>
</mat-menu>
            </div>
            
            <hr class="sidebar-divider" />
        </div>

        <ul class="sidebar-menu-list">
            @if (farmerData?.has_advices) {
            <li class="sidebar-menu-item">
                <a style="color: blue;" [routerLink]="['/tips']" class="sidebar-link">
                    <i class="pr-4 fas fa-comment-dots sidebar-icon"></i>
                    {{'SIDEBAR.FARMER_ADVICES' | translate }}
                </a>
            </li>
            }
            <li class="sidebar-menu-item">
                <a [routerLink]="['/']" class="sidebar-link">
                    <i class="fas fa-home pr-2 sidebar-icon sidebar-icon--default"></i>
                    {{'SIDEBAR.HOME' | translate }}
                </a>
            </li>
            <li class="sidebar-menu-item">
                <a [routerLink]="['/plots']" class="sidebar-link">
                    <i class="far fa-map pr-2 sidebar-icon sidebar-icon--default"></i>
                    {{'SIDEBAR.PLOTS' | translate }}
                </a>
            </li>
            
            <div *ngIf="featureFlags.isFeatureEnabled('showUruguay') else greece">
                <li class="sidebar-menu-item">
                    <a [routerLink]="['/pests']" class="sidebar-link">
                        <i class="fas fa-bug pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'PEST.PAGE' | translate }}
                    </a>
                </li>
                <li class="sidebar-menu-item">
                    <a [routerLink]="['/devices']" class="sidebar-link">
                        <i class="fa-solid fa-desktop pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'SIDEBAR.DEVICES' | translate }}
                    </a>
                </li>
                <li class="sidebar-menu-item">
                    <a [routerLink]="['/weather-stations']" class="sidebar-link">
                        <i class="fa-solid fa-cloud-sun pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'SIDEBAR.WEATHER' | translate }}
                    </a>
                </li>
            </div>
            
            <ng-template #greece>
                
                <li class="sidebar-menu-item">
                    <a (click)="toggleCultivationSupport()" class="sidebar-link sidebar-link--toggle">
                        <i class="fas fa-leaf pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'TIPS.CULTIVATION' | translate}}
                        <i class="fas sidebar-toggle-icon" 
                            [ngClass]="isCultivationSupportOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </a>
                </li>
                <div *ngIf="isCultivationSupportOpen" class="sidebar-submenu">
                    <li class="sidebar-menu-item">
                        <a (click)="navigateToPests('fertilizers')" class="sidebar-link sidebar-link--submenu">
                            <i class="fa-solid fa-leaf pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'PEST.FERTILISER_SIDEBAR_TITLE' | translate }}
                        </a>
                    </li>
                    <li class="sidebar-menu-item">
                        <a (click)="navigateToPests('diseases')" class="sidebar-link sidebar-link--submenu">
                            <i class="fas fa-bug pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'PEST.DISEASES_SIDEBAR_TITLE' | translate }}
                        </a>
                    </li>
                    <li class="sidebar-menu-item">
                        <a [routerLink]="['/carbon-footprint']" class="sidebar-link sidebar-link--submenu">
                            <i class="fas fa-leaf pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'SIDEBAR.CARBON' | translate }}
                        </a>
                    </li>
                    <li class="sidebar-menu-item">
                        <a [routerLink]="['/weather-stations']" class="sidebar-link sidebar-link--submenu">
                            <i class="fa-solid fa-cloud-sun pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'TIPS.CARD_WEATHER_TITLE' | translate}}
                        </a>
                    </li>
                </div>

                <li class="sidebar-menu-item">
                    <a (click)="toggleCropManagement()" class="sidebar-link sidebar-link--toggle">
                        <i class="fas fa-seedling pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'SIDEBAR.CROP_MANAGEMENT' | translate }}
                        <i class="fas sidebar-toggle-icon" 
                            [ngClass]="isCropManagementOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </a>
                </li>
                <div *ngIf="isCropManagementOpen" class="sidebar-submenu">
                    <li class="sidebar-menu-item">
                        <a [routerLink]="['/management/seeding-planting']" class="sidebar-link sidebar-link--submenu">
                            <i class="fas fa-seedling pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'MANAGEMENT.SEEDPLANT' | translate }}
                        </a>
                    </li>
                    <li class="sidebar-menu-item">
                        <a [routerLink]="['/management/crop']" class="sidebar-link sidebar-link--submenu">
                            <i class="fa-solid fa-wheat-awn pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'MANAGEMENT.CROP' | translate }}
                        </a>
                    </li>
                    <li class="sidebar-menu-item">
                        <a [routerLink]="['/management/treatment']" class="sidebar-link sidebar-link--submenu">
                            <i class="fas fa-tractor pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'MANAGEMENT.TREAT' | translate }}
                        </a>
                    </li>
                    <li class="sidebar-menu-item">
                        <a [routerLink]="['/management/traps']" class="sidebar-link sidebar-link--submenu">
                            <i class="fas fa-bug-slash pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'SIDEBAR.DACUS' | translate}}
                        </a>
                    </li>
                </div>

                <li class="sidebar-menu-item">
                    <a (click)="toggleStorageManagement()" class="sidebar-link sidebar-link--toggle">
                        <i class="fas fa-warehouse pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'SIDEBAR.STORAGE_EQUIPMENT_MANAGEMENT' | translate }}
                        <i class="fas sidebar-toggle-icon" 
                            [ngClass]="isStorageManagementOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </a>
                </li>
                <div *ngIf="isStorageManagementOpen" class="sidebar-submenu">
                    <li class="sidebar-menu-item">
                        <a [routerLink]="['/management/products']" class="sidebar-link sidebar-link--submenu">
                            <i class="fa-solid fa-boxes-stacked pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'MANAGEMENT.PRODUCT' | translate }}
                        </a>
                    </li>
                    <li class="sidebar-menu-item">
                        <a [routerLink]="['/management/equipment']" class="sidebar-link sidebar-link--submenu">
                            <i class="fa-solid fa-screwdriver-wrench pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'SIDEBAR.EQUIPMENT' | translate }}
                        </a>
                    </li>
                    <li class="sidebar-menu-item">
                        <a [routerLink]="['/management/storage']" class="sidebar-link sidebar-link--submenu">
                            <i class="fas fa-warehouse pr-2 sidebar-icon sidebar-icon--submenu-default"></i>
                            {{'SIDEBAR.STORAGE' | translate }}
                        </a>
                    </li>
                </div>
                
                <li class="sidebar-menu-item">
                    <a [routerLink]="['/upload']" class="sidebar-link">
                        <i class="fas fa-upload pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'SIDEBAR.UPLOAD' | translate }}
                    </a>
                </li>
                <li class="sidebar-menu-item">
                    <a [routerLink]="['/history']" class="sidebar-link">
                        <i class="far fa-clipboard pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'SIDEBAR.HISTORICAL' | translate }}
                    </a>
                </li>
                <li class="sidebar-menu-item">
                    <a [routerLink]="['/reports']" class="sidebar-link">
                        <i class="fas fa-pen-to-square pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'SIDEBAR.REPORTS' | translate }}
                    </a>
                </li>
                <li class="sidebar-menu-item">
                    <a [routerLink]="['/contact-us']" class="sidebar-link">
                        <i class="fa-solid fa-envelope pr-2 sidebar-icon sidebar-icon--default"></i>
                        {{'SIDEBAR.CONTACT' | translate }}
                    </a>
                </li>
            </ng-template>

            <div class="sidebar-logo-footer">
                <img src="../../../assets/logoWiGrow.jfif" [routerLink]="['/']"
                    class="sidebar-logo sidebar-logo--footer">
            </div>
        </ul>
    </mat-sidenav>
    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>